import { Theme, createStyles } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { StyleRules } from '@material-ui/core/styles/withStyles';

const styles = (theme: Theme): StyleRules<string, {}> => createStyles({
  root: {
    height: '100vh',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  formControl: {
    margin: `${theme.spacing(1)}px auto`,
    width: '80%',
    '& .MuiInputLabel-outlined.MuiInputLabel-marginDense': {
      transform: 'translate(14px, 20px) scale(1)',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
  },
  formControlLabel: {
    marginLeft: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  loginBody: {
    height: 400,
    width: 360,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: '100%',
    },
  },
  logoContainer: {
    height: 100,
    marginTop: theme.spacing(1.5),
  },
  logo: {
    display: 'block',
    maxHeight: '100%',
    maxWidth: '90%',
    margin: `${theme.spacing(1)}px auto`,
  },
  version: {
    color: grey[500],
  },
});

export default styles;
